import PropTypes from "prop-types"
import styled from "styled-components"
import media from "@styles/media"
import Div from "./div"
import { cssConfig } from "@utils/css-validator"

const Grid = styled(Div).withConfig(cssConfig)`
  align-items: ${props => props.alignItems};
  justify-content: ${props => props.justifyContent};
  justify-items: ${props => props.justifyItems};
  grid-template-areas: ${props => props.areas && `"${props.areas}"`};

  gap: ${props => props.gap};
  grid-template-columns: ${props => props.columns};
  grid-template-rows: ${props => props.rows};

  ${media.md`
    gap: ${props => props.gapMd};
    grid-template-columns: ${props => props.columnsMd};
    grid-template-rows: ${props => props.rowsMd};
  `}

  ${media.sm`
    gap: ${props => props.gapSm};
    grid-template-columns: ${props => props.columnsSm};
    grid-template-rows: ${props => props.rowsSm};
		&:nth-child(2n + 2) > div:first-child {
			order: ${props => props.collapse && "2"};
		}	
	`}
`

Grid.defaultProps = {
  display: "grid",
}

Grid.propTypes = {
  alignItems: PropTypes.string,
  justifyContent: PropTypes.string,
  justifyItems: PropTypes.string,

  gapSm: PropTypes.string,
  gapMd: PropTypes.string,
  gap: PropTypes.string,

  columnsSm: PropTypes.string,
  columnsMd: PropTypes.string,
  columns: PropTypes.string,

  rowsSm: PropTypes.string,
  rowsMd: PropTypes.string,
  rows: PropTypes.string,

  areas: PropTypes.string,
  collapse: PropTypes.bool,
}

export default Grid
